import React from 'react';

import {
  Breakpoints,
  Tabs,
  TextAlignment,
  TextAppearance,
  TextCustom,
  TextLineHeight,
  TextSize,
  TextTag,
  TextWeight,
} from '@vw-marketing/us-components';

import { StyledTabsWrapper } from './styles';
import { useModelsCarouselContext } from '../../hooks/use-models-carousel-context';
import { useTrackingManager } from '../../hooks/use-tracking-manager';
import {
  onVWBasicFilterResultLoad,
  onVWBasicFilterSelect,
} from '../../tagging/tagging-helpers';
import { removePluralS } from '../../utils/general';

export interface TabItem {
  content: React.ReactElement;
  labelKey: string;
  key: string;
}

interface TabsProps {
  tabs: TabItem[];
}

const getCurrentFilter = (tabs: TabItem[], index: number) => {
  return tabs.find((_, tabIndex) => tabIndex === index);
};

export const TabsData: React.FC<TabsProps> = ({ tabs }) => {
  const { translationHandler } = useModelsCarouselContext();
  const trackingManager = useTrackingManager();

  const tabItems = tabs.map((item) => ({
    title: (
      <TextCustom
        appearance={TextAppearance.label200}
        tag={TextTag.p}
        style={{
          [Breakpoints.default]: {
            fontWeight: TextWeight.bold,
            fontSize: TextSize.TextSize16,
            lineHeight: TextLineHeight.TextLineHeight20,
            textAlign: TextAlignment.left,
          },
        }}
      >
        {translationHandler(item.labelKey)}
      </TextCustom>
    ),
    content: item.content,
    key: item.key,
  }));

  const handleFilterSelectTracking = (index: number) => {
    const currentFilter = getCurrentFilter(tabs, index);

    if (!currentFilter) return;

    const tabLabel = translationHandler(currentFilter?.labelKey || '');

    const vehicles = currentFilter?.content.props.vehicles || [];
    const vehicleNames = vehicles.map((vehicle: any) => vehicle.name);

    onVWBasicFilterSelect(trackingManager, tabLabel, vehicleNames);
  };

  const handleFilterResultLoadTracking = (index: number) => {
    const currentFilter = getCurrentFilter(tabs, index);

    if (!currentFilter) return;

    const tabName = removePluralS(translationHandler(currentFilter?.labelKey || ''));

    const vehicles = currentFilter?.content.props.vehicles || [];

    onVWBasicFilterResultLoad(trackingManager, tabName, vehicles);
  };

  return (
    <StyledTabsWrapper>
      <Tabs
        variant="floating"
        tabBarVerticalPosition="bottom"
        idPrefix="carousel"
        scrollable
        onChange={(index: number) => {
          handleFilterSelectTracking(index);
          handleFilterResultLoadTracking(index);
        }}
      >
        {tabItems}
      </Tabs>
    </StyledTabsWrapper>
  );
};
